module.exports = __webpack_public_path__ + "img/liberty.60b9f477.svg";